var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-pt-login',{ref:"form",staticClass:"pt-pt-login__withData",on:{"getCode":_vm.getCode,"loginSubmit":_vm.loginSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }